export default {
  navigationBarTitleText: '标准服务流程须知'
}
